<template>
    <div class="s-loading" :style="{width : width,height : height, borderRadius : borderRadius, marginBottom : marginBottom}"></div>
</template>

<script>
export default {
    props : {
        width : {
            type : String,
            default : '100%'
        },
        height : {
            type : String,
            default : '100%'
        },
        borderRadius : {
            type : String,
            default : '5px'
        },
        marginBottom : {
            type : String,
            default : '5px'
        },
    }
}
</script>

<style lang="scss" scoped>
    .s-loading { 
        position: relative; 
        overflow: hidden;
        background-color: #e2e2e2; 
    } 
   
    /* The moving element */
    .s-loading::after { 
        display: block; 
        content: ""; 
        position: absolute; 
        width: 100%; 
        height: 100%; 
        transform: translateX(-100%); 
        background: -webkit-gradient(linear, left top, 
                    right top, from(transparent),  
                    color-stop(rgba(255, 255, 255, 0.2)), 
                    to(transparent)); 
                      
        background: linear-gradient(90deg, transparent, 
                rgba(255, 255, 255, 0.2), transparent); 
   
        /* Adding animation */
        animation: loading 0.8s infinite; 
    } 
   
    /* Loading Animation */
    @keyframes loading { 
        100% { 
            transform: translateX(100%); 
        } 
    }

</style>